import { useEffect } from 'react';
import { useApiContext, useGetFullInfo } from 'react-easyrocket';

export const useLiveChatAuth = () => {
  const { isAuthenticated } = useApiContext();
  const { fullInfo } = useGetFullInfo();

  useEffect(() => {
    if (!window.LiveChatWidget) return;
    if (!fullInfo?.email || !isAuthenticated) return;
    window.LiveChatWidget.call('set_customer_email', fullInfo.email);
    if (fullInfo.name) {
      window.LiveChatWidget.call('set_customer_name', fullInfo.name);
    }
    window.LiveChatWidget.call('set_session_variables', {
      loyaltyLevel: fullInfo?.level
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullInfo?.email, isAuthenticated]);
};
